module.exports = __webpack_public_path__ + "static/img/top1_i2_nav.72ff136b.png";